import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteProductDelivery, setDeleteProductDeliveryId} from "../../actions/product-delivery";

const ProductDeliveryDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_product_delivery, currentPage, numberOfPages, product_deliveries} = useSelector(state => state.product_delivery);

    const closeModal = () =>{
        dispatch(setDeleteProductDeliveryId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage == numberOfPages) && (product_deliveries.length == 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteProductDelivery(delete_product_delivery.id, getPage))
    };

    let condition = false;
    if(delete_product_delivery !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >Mahsulot yetkazib berishni o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu product deliveryni o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ProductDeliveryDeleteForm;